<template>
    <div class="component-settings-menu">
        <!--
        <el-radio-group v-model="isCollapse">
        <el-radio-button :label="false">expand</el-radio-button>
        <el-radio-button :label="true">collapse</el-radio-button>
        </el-radio-group>
        -->
        <el-menu :default-active="getActiveIndex()" :mode="menuMode" :class="menuMode === 'vertical' ? 'el-menu-vertical' : 'el-menu-horizontal'"  @open="handleOpen" @close="handleClose" :collapse="isCollapse" :router=true>
            <div style="display: inline-block; height: 65px;" v-if="menuMode === 'vertical'">
                <h4 class="pl-20 pt-20">Settings</h4>
                <p class="title pl-20 pt-20 mb-0">Organisation</p>
                <p class="pl-20">{{$store.state.general.orgName}}</p>
                <div v-if="superuser()"><p class="pl-20 pr-20 inline">Dev mode</p><el-switch class="inline" @change="changeDevMode" v-model="$store.state.general.devMode"></el-switch></div>
            </div>
            <el-menu-item :style="menuMode === 'vertical' ? {'margin-top': '10px'} : {}" index="1" :route="{name: 'settings-overview'}">
                <i class="el-icon-info"></i>
                <span slot="title">Overview</span>
            </el-menu-item>
            <el-menu-item index="2" :route="{name: 'settings-users'}">
                <i class="el-icon-user-solid"></i>
                <span slot="title">Users</span>
            </el-menu-item>
            <el-menu-item index="3" :route="{name: 'settings-interests'}">
                <i class="el-icon-message-solid"></i>
                <span slot="title">Interests</span>
            </el-menu-item>
            <el-menu-item index="4" :route="{name: 'settings-stores'}">
                <i class="el-icon-s-shop"></i>
                <span slot="title">Stores</span>
            </el-menu-item>
            <el-menu-item index="5" :route="{name: 'settings-cycles'}">
                <i class="el-icon-s-help"></i>
                <span slot="title">Cycles</span>
            </el-menu-item>
            <el-menu-item index="6" :route="{name: 'settings-data'}">
                <i class="el-icon-s-data"></i>
                <span slot="title">Data</span>
            </el-menu-item>
            <el-menu-item v-if="showItem()" index="7" :route="{name: 'settings-playground'}">
                <i class="el-icon-lollipop"></i>
                <span slot="title">Playground</span>
            </el-menu-item>
        </el-menu>
    </div>
</template>

<script>
// import axios from '@/services/axios.js'
// import { getHeadersWithAccessToken } from '../../functions.js'
import vue from 'vue'

export default {
    data () {
        return {
            isCollapse: false,
            // orgName: '',
            width: 0,
            menuMode: this.width < 1024 ? 'horizontal' : 'vertical'

        }
    },

    computed: {
    },

    methods: {
        showItem () {
            let roles = localStorage.getItem('roles').split(',')
            if (roles.includes('0') || roles.includes('1') || roles.includes('2') || roles.includes('7')) {
                return true
            } else {
                return false
            }
        },
        handleOpen (key, keyPath) {
            console.log(key, keyPath)
        },
        handleClose (key, keyPath) {
            console.log(key, keyPath)
        },
        getActiveIndex () {
            let page = this.$route.path.split('settings/')[1]
            if (page === 'overview') {
                return '1'
            } else if (page === 'users' || page === 'user-detail' || page === 'invite-user') {
                return '2'
            } else if (page === 'interests') {
                return '3'
            } else if (page === 'stores' || page === 'store-detail') {
                return '4'
            } else if (page === 'cycles') {
                return '5'
            } else if (page === 'data') {
                return '6'
            } else if (page === 'playground') {
                return '7'
            }
        },
        handleResize () {
            this.width = window.innerWidth
            this.menuMode = this.width < 1024 ? 'horizontal' : 'vertical'
            vue.set(this.$store.state.general, 'settingsMenuMode', this.menuMode)
            this.$emit('changed')
        },
        superuser () {
            return (localStorage.getItem('roles').split(',').includes('0'))
        },
        changeDevMode () {
            if (localStorage.getItem('devMode') === 'true') {
                localStorage.setItem('devMode', false)
                this.$router.go()
            } else {
                localStorage.setItem('devMode', true)
                this.$router.go()
            }
        }
    },
    created () {
        // axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at/general/general/org_details', { 'format': 'd' }, { 'headers': getHeadersWithAccessToken() })
        //     .then(response => {
        //         this.orgName = response.data.data['org_name']
        //     }).catch(error => {
        //         console.log(error)
        //     })
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    },
    destroyed () {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>

<style lang="scss">
.component-settings-menu {
    .el-menu-vertical:not(.el-menu--collapse) {
        width: 200px;
        min-height: 500px !important;
    }
    .el-menu-vertical {
        border: solid 1px #EBEEF5;
        text-align: left;
        display: inline-block;
        float: left;
        min-height: 500px !important;
        margin-right: 20px;
    }
    .el-menu-horizontal {
        border: solid 1px #EBEEF5;
        display: block;
        margin-bottom: 50px;
    }

    .el-menu--horizontal>.el-menu-item {
        width: 100px;
    }

    .el-menu--horizontal>.el-menu-item.is-active  {
        border-bottom: none;
    }

    p.title {
        font-weight: 800;
    }
}
</style>
